import oits from './oits';
import oitTasks from './oit-tasks';
import oitTrainingPhases from './oit-training-phases';

const oitsActions = {
  ...oits,
  ...oitTasks,
  ...oitTrainingPhases,
};

export default oitsActions;
